import _get from 'lodash/get';
import useProfileAppContext from './use-profile-app-context';

import { useProfileFootnotes } from '../../hooks/api';
import { PROFILE_API_TYPES } from '../../hooks/api/_constants';

const useProfileCommonStore = () => {
  const {
    apiClient,
    assetClass,
    auxiliary,
    channel,
    fundType,
    pageOffsetsTop,
    sideRail,
    xref = {}
  } = useProfileAppContext();

  const apiType = PROFILE_API_TYPES.prop;

  // TIAA-13199: When the xid is 'undefined', assign an integer '0' to xid. It will make the rest of API run without error.
  let xid = _get(xref, 'data.xid');
  if (xref?.isLoaded && (!xid || xid === undefined)) {
    xid = 0;
  }
  const isProprietaryFund = _get(auxiliary, 'data.isTcFund');

  const apiConfigBase = {
    apiType,
    channel,
    client: apiClient,
    xid
  };

  // TODO: Move this. Right now, it causes a new API call every time this hook is used.
  const footnotes = useProfileFootnotes({ ...apiConfigBase, shouldLoad: !!xid })
    .data;

  return {
    apiConfigBase,
    commonState: {
      assetClass,
      auxiliary,
      channel,
      fundType,
      footnotes,
      hideForPWAChannelMobile: channel === 'pwa',
      isProprietaryFund,
      pageOffsetsTop,
      sideRail,
      xref
    }
  };
};

export default useProfileCommonStore;
